import { Observable, throwError as observableThrowError } from 'rxjs';

import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Map } from 'immutable';
import { catchError, filter, map, take } from 'rxjs/operators';
import { AppState } from 'src/app';
import { NotificationService } from 'src/core/services/notification.service';
import {
  UserPreferences,
  LegacyWatchList,
  FeatureType,
} from '@models/user-preferences';
import { ApiGatewayService } from 'src/shared';

@Injectable()
export class UserPreferencesService {
  private tradingUrl = '/user-preferences';
  private appConfiguration$: Observable<any>;
  private api: string;
  private gbmComAPI: string;

  constructor(
    private store: Store<AppState>,
    private apiGatewayService: ApiGatewayService,
    private notificationService: NotificationService,
  ) {
    this.appConfiguration$ = this.store.select('config');

    this.appConfiguration$
      .pipe(filter((mapShadowed) => Map.isMap(mapShadowed)))
      .subscribe((apiConfig) => {
        this.api = apiConfig.get('userPreferencesApi').concat(this.tradingUrl);
        this.gbmComAPI = apiConfig.get('gbmComApi');
      });
  }

  getLegacyWatchList(): Observable<LegacyWatchList[]> {
    return this.apiGatewayService
      .get(`${this.gbmComAPI}v1/users/watchlist`)
      .pipe(
        catchError((error: any) => {
          this.notificationService.showServiceError(error);
          return observableThrowError(error);
        }),
        take(1),
      );
  }

  createPreference(
    feature: FeatureType,
    preference: UserPreferences,
  ): Observable<UserPreferences> {
    return this.apiGatewayService
      .post(`${this.api}/${feature}`, preference)
      .pipe(
        catchError((error: any) => {
          this.notificationService.showServiceError(error);
          return observableThrowError(error);
        }),
        take(1),
      );
  }

  getPreference(feature: FeatureType): Observable<UserPreferences[]> {
    return this.apiGatewayService.get(`${this.api}/${feature}`).pipe(
      catchError((error: any) => {
        this.notificationService.showServiceError(error);
        return observableThrowError(error);
      }),
      take(1),
    );
  }

  updatePreference(
    feature: FeatureType,
    id: string,
    preference: UserPreferences,
  ): Observable<UserPreferences> {
    return this.apiGatewayService
      .patch(`${this.api}/${feature}/${id}`, preference)
      .pipe(
        catchError((error: any) => {
          this.notificationService.showServiceError(error);
          return observableThrowError(error);
        }),
        take(1),
      );
  }

  deletePreference(feature: FeatureType, groupId: string): Observable<void> {
    return this.apiGatewayService
      .delete(`${this.api}/${feature}/${groupId}`)
      .pipe(
        catchError((error: any) => {
          this.notificationService.showServiceError(error);
          return observableThrowError(error);
        }),
        take(1),
      );
  }
}
